import React from 'react';
import { Icon } from '../../../components/ds';

const StrategyCompare = ({ isOpen, onClose, versions }) => {
  if (!isOpen) return null;

  // Mock Parameter Diffing Logic (Simplified)
  // In reality, this would recursively compare the JSON config
  const parameters = [
    { name: "RSI Period", key: "rsi_period", v1: 14, v2: 10, v3: 10 },
    { name: "Stop Loss %", key: "stop_loss", v1: 2.0, v2: 2.0, v3: 1.5 },
    { name: "Take Profit %", key: "take_profit", v1: 4.0, v2: 4.0, v3: 4.0 },
    { name: "EMA Filter", key: "ema_period", v1: 200, v2: 200, v3: 200 },
  ];

  return (
    <div
      className="fixed inset-0 z-[1200] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="w-full max-w-[1200px] h-[90%] flex flex-col overflow-hidden rounded-2xl bg-bg-2 border border-[var(--divider)] shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-[var(--divider)]">
          <h2 className="text-lg font-bold text-fg-1">Compare Versions</h2>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="close" size={16} />Close
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-auto p-6">
          <div className="overflow-x-auto rounded-lg border border-[var(--divider)]">
            <table className="w-full text-sm border-collapse">
              <thead>
                <tr>
                  <th className="w-[20%] text-left font-bold text-fg-1 px-4 py-3 border-b border-[var(--divider)]">
                    Feature / Metric
                  </th>
                  {versions.map(ver => {
                    const active = ver.status === 'Active';
                    return (
                      <th
                        key={ver.id}
                        className={`text-center px-4 py-3 border-b-2 ${active ? 'bg-bg-3' : ''}`}
                        style={{ borderBottomColor: active ? 'var(--badge-profit-dot)' : 'var(--divider)' }}
                      >
                        <div className="font-bold text-fg-1">{ver.name}</div>
                        <span className="ds-badge sm neutral mt-2">{ver.tag}</span>
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {/* Performance Metrics Section */}
                <tr>
                  <td colSpan={versions.length + 1} className="bg-bg-3 font-bold text-fg-2 px-4 py-2 text-xs uppercase tracking-wide">
                    Performance Metrics
                  </td>
                </tr>
                <tr className="border-t border-[var(--divider)]">
                  <td className="px-4 py-2.5 text-fg-2">Win Rate</td>
                  {versions.map(ver => (
                    <td
                      key={ver.id}
                      className={`text-center px-4 py-2.5 font-bold font-mono ${ver.metrics.winRate > 50 ? 'text-profit' : 'text-fg-2'}`}
                    >
                      {ver.metrics.winRate}%
                    </td>
                  ))}
                </tr>
                <tr className="border-t border-[var(--divider)]">
                  <td className="px-4 py-2.5 text-fg-2">Profit Factor</td>
                  {versions.map(ver => (
                    <td key={ver.id} className="text-center px-4 py-2.5 font-mono text-fg-1">
                      {ver.metrics.profitFactor}
                    </td>
                  ))}
                </tr>

                {/* Parameters Section - Hardcoded Mock for Demo */}
                <tr>
                  <td colSpan={versions.length + 1} className="bg-bg-3 font-bold text-fg-2 px-4 py-2 text-xs uppercase tracking-wide">
                    Key Parameters
                  </td>
                </tr>
                {parameters.map((param) => (
                  <tr key={param.key} className="border-t border-[var(--divider)]">
                    <td className="px-4 py-2.5 text-fg-2">{param.name}</td>
                    {versions.map((ver, vIdx) => {
                      // Mock: map version index to mock data index (0, 1, 2)
                      // In real app, this reads ver.config[param.key]
                      const valKey = vIdx === 0 ? "v1" : vIdx === 1 ? "v2" : "v3";
                      const value = param[valKey];

                      // Highlight diff against first version (baseline)
                      const isDifferent = vIdx > 0 && param[valKey] !== param["v1"];

                      return (
                        <td
                          key={ver.id}
                          className="text-center px-4 py-2.5 font-mono text-fg-1"
                          style={isDifferent ? { backgroundColor: 'var(--badge-warn-bg)', color: 'var(--badge-warn-fg)' } : undefined}
                        >
                          {value}
                          {isDifferent && <span className="block text-[10px] text-fg-3 font-sans">(Changed)</span>}
                        </td>
                      );
                    })}
                  </tr>
                ))}

                {/* Actions Footer */}
                <tr className="border-t border-[var(--divider)]">
                  <td className="px-4 py-3" />
                  {versions.map(ver => (
                    <td key={ver.id} className="text-center px-4 py-3">
                      <button type="button" className="btn btn-secondary btn-sm"><Icon name="restore" size={16} />Restore</button>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StrategyCompare;
